var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIBotNav01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5386 21.0635H5.4614C4.10366 21.0635 3 19.9599 3 18.6021V9.91575C3 9.10587 3.40494 8.34363 4.0719 7.88311L10.6145 3.42876C11.4482 2.85708 12.5518 2.85708 13.3855 3.42876L19.9281 7.89104C20.603 8.35157 21 9.10587 21 9.92369V18.6101C21 19.9678 19.8963 21.0715 18.5386 21.0715V21.0635Z",
    fill: "#5697FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBotNav01);
export default __webpack_public_path__ + "static/media/i_bot_nav_01.3a59fddacd71b6507d7f7eeb86ea080d.svg";
export { ForwardRef as ReactComponent };